import { styled as r } from "styled-components";
import { system as l } from "styled-system";
const t = l({
  fillColor: {
    property: "fill",
    scale: "colors"
  },
  strokeColor: {
    property: "stroke",
    scale: "colors"
  }
}), p = /* @__PURE__ */ r.path.withConfig({
  shouldForwardProp: (o) => ![
    "fillColor",
    "strokeColor"
  ].includes(o),
  componentId: "sc-de930266-0"
})(t);
export {
  p as default,
  t as styledSvgColor
};
